module.exports = __webpack_public_path__ + "media/luxury-2026/terrace-chef-kitchen-960-5d00b623.jpg";